import { createActorContext } from '@xstate/react';
import { panelMachine } from '@/machines/panelMachine';

export const AiChatPanelContext = createActorContext(panelMachine);

export const AiChatPanelProvider = ({ children }: { children: React.ReactNode }) => (
    <AiChatPanelContext.Provider>
        {children}
    </AiChatPanelContext.Provider>
);
